import get from 'lodash/get';

export const getSelectHub = (state) => get(state, 'auth.forgotPassword.selectHub', false);

export const getSelectAvailableHubs = (state) => {
  return get(state, 'auth.forgotPassword.selectAvailableHubs', []);
};
